import * as Progress from '@radix-ui/react-progress';
import { tk } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

const ProgressRoot = styled(Progress.Root)`
  position: relative;
  overflow: hidden;
  background: ${tk('color_semantic_bg_strong')};
  border-radius: ${tk('radius_rounded')};
  width: 100%;
  height: ${tk('spacing_xs')};

  /* Fix overflow clipping in Safari */
  /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
  transform: translateZ(0);
`;

const ProgressIndicator = styled(Progress.Indicator)`
  background-color: ${tk('color_semantic_bg_inverse')};
  width: 100%;
  height: 100%;
`;

interface BarProps {
  score: number;
}

export function Bar({ score }: BarProps) {
  return (
    <ProgressRoot value={score} max={40}>
      <ProgressIndicator style={{ transform: `translateX(-${100 - score}%)` }} />
    </ProgressRoot>
  );
}
